(function () {
  angular.module('MktzapApp.Controllers')
    .controller('DashboardRotationController', dashboardRotation);
  dashboardRotation.$inject = ['$http', '$state', 'AuthenticationService', '$rootScope', 'NotificationService'];
  function dashboardRotation ($http, $state, AuthenticationService, $rootScope, NotificationService) {
    var vmDashRot = this;

    vmDashRot.start = function () {
      var time = document.getElementById('time').value;
      var business = document.getElementById('business').checked;
      var team = document.getElementById('team').checked;
      var op = document.getElementById('operational').checked;
      var dash;

      if (!time) {
          		NotificationService.warningHandler(null, $rootScope.labels.requiredTime);
          		return;
      }

      if (document.querySelectorAll('input[type="checkbox"]:checked').length < 2) {
        NotificationService.warningHandler(null, $rootScope.labels.selectDash);
        return;
      }

      if (business) {
        dash = 'main.dashboard-business-management';
      } else if (team) {
        dash = 'main.dashboard-team-management';
      }

      $state.go(dash, {
        time: time * 60000,
        business: business,
        team: team,
        op: op,
        from: null,
        to: null
      });
    }
  }
})();
